import {Alert, Button, Card, Col, Flex, Form, Input, Row, Spin} from "antd";
import {Submit} from "../../components/login/items/Submit";
import {Reset} from "../../components/login/items/Reset";
import {AuthService} from "../../services/Auth.service";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {HttpService} from "../../services/http/Http.service";
import {useEffect, useState} from "react";
import {AuthBodyModel, LoginModel, RoutingURL} from "../../model/models";

export function Login() {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    function reset() {
        form.resetFields();
    }

    function onFinish(values: AuthBodyModel) {
        AuthService.login(values).then(() => {
            navigate(RoutingURL.HOME);
        })
    }

    /*    function goToRegistration(){
            navigate(AppRoutingURL.REGISTRATION_COMPANY);
        }*/

    function when(value: any) {
        return new Promise(function (resolve, reject) {
            resolve(value)
        });
    }

    function azureLogin() {
        const response = HttpService.getInstanceAxios().get(`/auth/azureGetLoginUrl`);
        response.then(response => {
            const url: any = response.data;
            console.log("REDIRECTING TO " + url);
            window.location.href = url;
        })
    }

    function loginAzure(code: string, state: string, session_state: string): Promise<any> | any {
        return HttpService.getInstanceAxios().post(`/auth/azureCallback`, {code, state, session_state});
    }

    function tryLogin() {
        console.log("try Login Azure...")

        //this.state.azureMode=true;

        //if(this.state.azureMode) {
        const urlParams = new URLSearchParams(window.location.search);
        const accessToken = urlParams.get('code');
        const sessionState = urlParams.get('session_state');
        const state = urlParams.get('state');
        console.debug("GOT \nsession_state=" + sessionState + "\naccessToken=" + accessToken + "\nstate=" + state);

        if (accessToken && sessionState && state) {
            setLoading(true);

            when(loginAzure(accessToken, state, sessionState)).then((result: any) => {

                //this.state.loading = false;
                console.debug(result);

                if (result && result.data) {
                    /*AuthService.setUser({
                        username:result.data.appUser.username,
                        lastname:"",
                        id:result.data.appUser.username,
                        permissions:[]
                    })*/
                    AuthService.setToken({id_token: result.data})
                    //window.sessionStorage.setItem('username',result.data.appUser.username);
                    navigate(RoutingURL.HOME);
                }
            }).catch((err: any) => {
                console.error(err);
                setLoading(false);
                azureLogin();
            });
        } else {
            //azureLogin();
            setLoading(false);
        }
    }

    useEffect(() => {
        tryLogin();
    }, [])

    const showLoginForm = process.env.REACT_APP_PASSWORD_LOGIN === "true";
    console.log("showLoginForm:", showLoginForm)
    const rulesPassword = [{required: true,}];
    const rulesUsername = [{required: true, message: t("please_input_your_username")}];
    return <>
        <Row
            justify="center"
            align="middle"
            className={"login"}>
            <Col>
                <Spin tip="Login in corso..." spinning={loading}>
                    <Card className={"login-card"}>
                        <div style={{textAlign: "center"}}>
                            <img src="/logoBig.png" alt="Logo" style={{height: "180px"}}/>
                        </div>
                        {showLoginForm ? (<Form
                                form={form}
                                name="basic"
                                onFinish={onFinish}
                            >


                                <Form.Item<LoginModel>
                                    label="Utente"
                                    name="username"
                                    rules={rulesUsername}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item<LoginModel>
                                    label="Password"
                                    name="password"
                                    rules={rulesPassword}
                                >
                                    <Input.Password/>
                                </Form.Item>

                                <Flex gap="middle" justify="flex-end">
                                    <Reset onReset={reset}></Reset>
                                    <Submit labelKey={"Login"}></Submit>
                                </Flex>


                            </Form>
                        ) : ''}
                        <Row
                            justify="center"
                            align="middle">
                            <Button type="primary" htmlType="button" onClick={azureLogin}>
                                {t("Accedi con Azure AD")}
                            </Button>
                        </Row>
                    </Card>
                </Spin>
            </Col>
        </Row>
    </>
}
